export class Labels {
  public static readonly Stage: string = "Stage";
  public static readonly DomicileSprite: string = "Domicile";
  public static readonly Doors: string = "Doors";
  public static readonly Door: string = "Door";
  public static readonly DoorImage: string = "DoorImage";
  public static readonly HardwareImage: string = "HardwareImage";
  public static readonly DoorPerimeter: string = "DoorPerimeter";
  public static readonly ModificationPoints: string = "ModificationPoints";
  public static readonly MagnificationContainer: string = "MagnificationContainer";
  public static readonly MagnificationImage: string = "MagnificationImage";
  public static readonly MagnificationMask: string = "MagnificationMask";
  public static readonly MagnificationPerimeter: string = "MagnificationPerimeter";
  public static readonly MagnificationTargetContainer: string = "MagnificationTargetContainer";
  public static readonly TopLeftPoint: string = "TopLeftPoint";
  public static readonly TopRightPoint: string = "TopRightPoint";
  public static readonly BottomLeftPoint: string = "BottomLeftPoint";
  public static readonly BottomRightPoint: string = "BottomRightPoint";
  public static readonly ChamferEdgeLeft: string = "ChamferEdgeLeft";
  public static readonly ChamferEdgeRight: string = "ChamferEdgeRight";
  public static readonly ArchEdgeLeft: string = "ArchEdgeLeft";
  public static readonly ArchDoorImageContainer: string = "ArchDoorImageContainer";
  public static readonly ArchHardwareImageContainer: string = "ArchHardwareImageContainer";
  public static readonly ArchSprite: string = "ArchSprite";
  public static readonly ArchMask: string = "ArchMask";
  public static readonly ChamferMask: string = "ChamferMask";
}
